import { useRef, useEffect } from 'react';
import { createBrowserHistory } from 'history';
import capitalize from 'lodash/fp/capitalize';

import segment from 'common/segment';

const BASE_PATH = '/build-your-plan';

function getStepIndexFromPath(steps) {
  const pathChunks = document.location.pathname.split('/');
  const lastChunk = pathChunks[pathChunks.length - 1];
  let stepIndex = 0;
  steps.forEach((step, index) => {
    if (step.slug === lastChunk) {
      stepIndex = index;
    }
  });
  return stepIndex;
}

export function useHistoryStepsSynchronization({
  steps,
  currentStep,
  setCurrentStep,
  loadingInitialData,
}) {
  const history = useRef();

  useEffect(() => {
    if (loadingInitialData) return;

    if (history.current) return;

    history.current = createBrowserHistory();

    // All initial data has been loaded now, so we can load
    // the current step from the browser URL.
    setCurrentStep(getStepIndexFromPath(steps));
    return;
  }, [currentStep, loadingInitialData, setCurrentStep, steps]);

  useEffect(() => {
    if (loadingInitialData) return;

    // Keep browser history in sync when navigating between steps
    const name = steps[currentStep].slug;
    const path = `${BASE_PATH}/${name}`;
    history.current.push(path, { currentStep });
    segment.track(`AS Builder ${capitalize(name)} Page Viewed`);
  }, [loadingInitialData, steps, currentStep]);
}
